export default {"src":"/_next/static/media/yfi.106a24ce.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};